import type { components } from "@/api-schema";
import { ModelFamilyIdentifierProvider } from "@/api-schema-enums";

type ModelFamilyIdentifier = Pick<components["schemas"]["ModelFamilyIdentifier"], "identifier" | "provider">;

export function getModelFamilyDatId(identifiers?: readonly ModelFamilyIdentifier[] | null): string | undefined {
  return identifiers?.find((identifier) => identifier.provider === ModelFamilyIdentifierProvider.Dat)?.identifier;
}
